import { Injectable } from '@angular/core';
import {
  NetworkUtilsService,
  URL_DICT,
} from 'projects/app-core/src/service/network-utils.service';
import { KinestexExerciseResponse } from '../models/fitness/AnyoKinestexExcercise';
import { FitnessChallengesGridRequest } from '../models/fitness/fitnessChallengesGridRequest';
import { FitnessChallengesGridResponse } from '../models/fitness/fitnessChallengesGridResponse';
import { AnyoFitnessChallenges } from '../models/fitness/AnyoFitnessChallenges';
import { FitnessLogsGridRequest } from '../models/fitness/fitnessLogsGridRequest';
import { FitnessLogsGridResponse } from '../models/fitness/fitnessLogsGridResponse';

export interface AnyoChallengesCreateReq {
  applicableUsers?: string[];
  applicablePartners?: string[];
  visible: boolean;
  active: boolean;
  isTest: boolean;
  archive: boolean;
  countdown: number;
  showLeaderboard: boolean;
  exerciseId: string;
  challengeName: string;
  internalChallengeName: string;
  userDetails?: { id: string, email: string }[];
  challengeDescription: string;
}

@Injectable({
  providedIn: 'root',
})
export class PhysicalFitnessService {
  constructor(public api: NetworkUtilsService) { }

  public createFitnessChallenge(req: AnyoChallengesCreateReq) {
    return this.api.post(URL_DICT.adminfitnessChallengeCreateUrl, req);
  }

  public updateFitnessChallenge(req: AnyoChallengesCreateReq, id: string) {
    return this.api.post(URL_DICT.adminfitnessChallengeUpdateUrl + id, req);
  }
  public fetchAllExercises() {
    return this.api.get<KinestexExerciseResponse[]>(
      URL_DICT.adminfitnessExercisesAllUrl,
    );
  }

  public fetchFitnessChallengesGrid(gridReq: FitnessChallengesGridRequest) {
    return this.api.post<FitnessChallengesGridResponse>(
      URL_DICT.adminfitnessChallengesGetUrl,
      gridReq,
    );
  }

  public fetchFitnessChallengesById(id: string) {
    return this.api.get<AnyoFitnessChallenges>(
      URL_DICT.adminfitnessChallengesGetUrl + '/' + id,
    );
  }

  public fetchFitnessLogsGrid(gridReq: FitnessLogsGridRequest) {
    return this.api.post<FitnessLogsGridResponse>(URL_DICT.adminFitnessLogsGridUrl, gridReq);
  }
}
